import React from 'react';
import Currency from '../Currency';
import IHasLinkProps from './IHasLinkProps';
import { forHashLink } from '../NavigateAwayHelper';
import LinkThatCanBeDisabled from '../../shared/permissions/LinkThatCanBeDisabled';

interface IClosingCostsPaidAtClosing extends IHasLinkProps {
  ownerId: string;
  total: number | null;
  hasEditPermissions?: boolean;
}

/*tslint:disable-next-line:variable-name*/
const ClosingCostsPaidAtClosing = ({
  ownerId,
  total,
  onNavigateAway,
  hasEditPermissions,
}: IClosingCostsPaidAtClosing) => {
  return (
    <div className="cost-data__row cost-data__aligned-row">
      <div className="cost-data__content-cell cost-data__content-row-number" />
      <div className="cost-data__content-cell cost-data__content-name">Closing Costs Paid at Closing (J)</div>
      <div className="cost-data__content-cell cost-data__content-amount cost-data__content-amount--text-content">
        <LinkThatCanBeDisabled {...forHashLink(onNavigateAway(`section-a-j`))} disabled={!hasEditPermissions}>
          {typeof total === 'number' ? <Currency value={total} /> : 'None'}
        </LinkThatCanBeDisabled>
      </div>
      <div className="cost-data__content-cell cost-data__content-control" />
    </div>
  );
};

export default ClosingCostsPaidAtClosing;
